import React from 'react';
import classNames from 'classnames';

import css from './ListingTag.module.css';

const ListingTag = (props) => {
  const { className, text, symbol } = props;

  const classes = classNames(css.root, className);

  return (
    <div className={classes}>
      {symbol ? symbol : null}
      {text}
    </div>
  );
};

export default ListingTag;
